<svg xmlns:serif="http://www.serif.com/" width="100%" height="100%" viewBox="0 0 220 180" version="1.1"
    xmlns="http://www.w3.org/2000/svg" xml:space="preserve"
    style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
    aria-hidden="true">
    <rect x="0" y="0" width="220" height="180" style="fill:none;" />
    <g>
        <path
            d="M210.23,103.23c0,-55.355 -44.873,-100.23 -100.23,-100.23c-55.357,0 -100.23,44.875 -100.23,100.23c0,14.746 3.21,28.736 8.928,41.345l182.601,0c5.721,-12.609 8.931,-26.599 8.931,-41.345"
            style="fill:var(--svg-tertiary);fill-rule:nonzero;" />
        <path d="M12,145l194,0" style="fill:none;stroke:var(--svg-primary);stroke-width:2px;" />
        <path d="M2,145l6,0" style="fill:none;stroke:var(--svg-primary);stroke-width:2px;" />
        <path d="M212,145l6,0" style="fill:none;stroke:var(--svg-primary);stroke-width:2px;" />
        <path
            d="M145.783,172.894c0,2.37 -16.661,4.295 -37.216,4.295c-20.552,0 -37.212,-1.925 -37.212,-4.295c0,-2.371 16.66,-4.292 37.212,-4.292c20.555,0 37.216,1.921 37.216,4.292"
            style="fill:var(--svg-tertiary);fill-rule:nonzero;" />
        <path
            d="M164,73.945c0,-4.94 -4.004,-8.945 -8.945,-8.945l-92.11,0c-4.941,0 -8.945,4.005 -8.945,8.945l0,61.055l110,0l0,-61.055Z"
            style="fill:var(--svg-secondary);fill-rule:nonzero;" />
        <path d="M128.774,63.725l-65.516,0c-5.014,0 -9.081,4.064 -9.081,9.078l0,61.967l3.551,0l71.046,-71.045Z"
            style="fill:var(--white);fill-rule:nonzero;" />
        <path d="M124,162.534l-28,0l1.75,-13.534l24.5,0l1.75,13.534Z"
            style="fill:var(--white);fill-rule:nonzero;stroke:var(--svg-primary);stroke-width:2px;" />
        <path
            d="M129.813,169l-39.625,0c-1.537,0 -2.659,-1.858 -1.991,-3.461c1.115,-2.687 3.49,-4.539 6.236,-4.539l31.132,0c2.749,0 5.124,1.852 6.238,4.539c0.666,1.603 -0.45,3.461 -1.99,3.461Z"
            style="fill:var(--white);fill-rule:nonzero;stroke:var(--svg-primary);stroke-width:2px;" />
        <path
            d="M155.055,149c4.941,0 8.945,-4.205 8.945,-9.39l0,-4.61l-110,0l0,4.61c0,5.185 4.004,9.39 8.945,9.39l92.11,0Z"
            style="fill:var(--white);fill-rule:nonzero;stroke:var(--svg-primary);stroke-width:2px;" />
        <path
            d="M164,73.945c0,-4.94 -4.004,-8.945 -8.945,-8.945l-92.11,0c-4.941,0 -8.945,4.005 -8.945,8.945l0,61.055l110,0l0,-61.055Z"
            style="fill:none;stroke:var(--svg-primary);stroke-width:2px;" />
        <path
            d="M111.512,141.535c0,-0.835 -0.677,-1.513 -1.512,-1.513c-0.835,0 -1.512,0.678 -1.512,1.513c0,0.836 0.677,1.514 1.512,1.514c0.835,0 1.512,-0.678 1.512,-1.514Z"
            style="fill:none;stroke:var(--svg-primary);stroke-width:1px;" />
        <path
            d="M132,114c0,1.656 -1.286,3 -2.87,3l-38.26,0c-1.584,0 -2.87,-1.344 -2.87,-3l0,-24c0,-1.658 1.286,-3 2.87,-3l38.26,0c1.584,0 2.87,1.342 2.87,3l0,24m-6,-19l-16,11l-16,-11m-0.261,15l6.696,-4m25.826,4l-6.696,-4"
            style="fill:var(--white);fill-rule:nonzero;stroke:var(--svg-primary);stroke-width:2px;" />
        <path d="M117,104l10.762,22.613l5.086,-5.502l7.954,7l2.543,-2.751l-7.954,-7l4.457,-5.203l-22.848,-9.157Z"
            style="fill:var(--white);stroke:var(--svg-primary);stroke-width:2px;stroke-miterlimit:1.5;" />
    </g>
    @if (showCheckMark()) {
    <g>
        <circle cx="167" cy="148" r="30" style="fill:#28d400;" />
        <path d="M181.721,132.814l-21.339,21.339l-5.975,-5.975l-5.975,5.975l11.95,11.95l27.314,-27.314l-5.975,-5.975Z"
            style="fill:var(--white);fill-rule:nonzero;" />
    </g>
    }
</svg>